import {useEffect,useRef,type ReactNode} from 'react';

/** Presentation shell only: traps focus without changing transaction state. */
export function FocusDialog({children,onClose}:{children:ReactNode;onClose?:()=>void}){
  const root=useRef<HTMLDivElement>(null);
  const closeRef=useRef(onClose);
  closeRef.current=onClose;
  useEffect(()=>{
    const previous=document.activeElement as HTMLElement|null;
    const element=root.current;
    if(!element)return;
    const focusable=()=>Array.from(element.querySelectorAll<HTMLElement>('button:not(:disabled),input:not(:disabled),select,textarea,[tabindex="0"]')).filter(item=>item.getClientRects().length>0);
    focusable()[0]?.focus();
    const keydown=(event:KeyboardEvent)=>{
      if(event.key==='Escape'){event.preventDefault();closeRef.current?.();return;}
      if(event.key!=='Tab')return;
      const controls=focusable(),first=controls[0],last=controls[controls.length-1];
      if(!first){event.preventDefault();return;}
      if(event.shiftKey&&document.activeElement===first){event.preventDefault();last.focus();}
      else if(!event.shiftKey&&document.activeElement===last){event.preventDefault();first.focus();}
    };
    element.addEventListener('keydown',keydown);
    const overflow=document.body.style.overflow;
    document.body.style.overflow='hidden';
    return()=>{element.removeEventListener('keydown',keydown);document.body.style.overflow=overflow;previous?.isConnected&&previous.focus();};
  },[]);
  return <div ref={root} className="ui-dialog-root">{children}</div>;
}

export function PinKeypad({value,onChange,disabled}:{value:string;onChange:(value:string)=>void;disabled:boolean}){
  return <div className="ui-pin-keypad" role="group" aria-label="PIN 數字鍵盤">
    {['1','2','3','4','5','6','7','8','9','clear','0','back'].map(key=><button key={key} type="button" disabled={disabled} aria-label={key==='clear'?'清除 PIN':key==='back'?'刪除一位 PIN':key} onClick={()=>onChange(key==='clear'?'':key==='back'?value.slice(0,-1):(value+key).slice(0,8))}>
      {key==='clear'?'清除':key==='back'?'⌫':key}
    </button>)}
  </div>;
}
